import React, { Component } from 'react';
import Helmet from 'react-helmet';
import _, { filter } from 'lodash';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import logo from "../../resources/img/SentrySafe_Store_logo.png";
import Link from "../common/TrackedLink";
import logo2x from "../../resources/img/SentrySafe_Store_logo@2x.png";
import ButtonLink from '../common/TrackedButtonLink';

class WhereToBuy extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pageRefresh: false
		}
	}

	render() {
		return (
			<div className="where-to-buy">

				<Helmet>
					<title>Where To Buy - US Retailers &#124; SentrySafe</title>
					<meta name="description" content="Our US retailers offer a wide selection of SentrySafe products to meet your needs. Shop online or purchase in-store with our preferred retailers." />
					<meta id="ps-key" name="ps-key" content="5865-63407ff0b618f20018927a76"></meta>
					<meta name="ps-country" content="US" />
					<meta name="ps-language" content="en" />
					<script id='wtb-index-helmet_ps-widget' type="text/javascript" src="https://cdn.pricespider.com/1/lib/ps-widget.js" async></script>
					<script id='wtb-index-helmet_ps-utid' type="text/javascript" src="https://cdn.pricespider.com/1/5865/ps-utid.js" async></script>
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Where to Buy" />
				</Breadcrumb>

				<header className="row header-callout">
					<div className="col">
						<h1>Where to Buy</h1>
						<p>Our retailers offer a wide selection of SentrySafe products to meet your needs. Browse our preferred retailers.</p>
					</div>
				</header>

				<section className="preferred-retailers">
					<div className="row">
						<div className="col text-center">
							<h2 className="pt-3 pb-2">Our Preferred Retailers</h2>
							<p style={{ fontSize: '.9em' }}>Buy now from the <a href="https://store.sentrysafe.com">SentrySafe Store</a> and get Free Shipping on all shipments to the contiguous United States.</p>
							<p>View U.S. and Canada Retailers below. Visit this page to <a href="/where-to-buy-intl">view International Distributors</a>.</p>
						</div>
					</div>
					<div className='row'>
						<div className='col'>
							<div className='col wtb-ps-wrapper' id='ps-wrapper'>
								<div className='ps-widget' data-ps-sku="''"></div>
							</div>
						</div>
					</div>

				</section >
			</div >
		);
	}
};

export default WhereToBuy;


// WEBPACK FOOTER //
// ./src/pages/whereToBuy/Index.js